import React, { useEffect, useRef, useState } from 'react';

// Public site key already used by the production lead form; never put the secret here.
const SITE_KEY = '0x4AAAAAAEHho01hlbvz1QbX';

export default function Turnstile({ action, onToken, resetKey = 0 }) {
  const container = useRef(null);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let disposed = false;
    let widget;
    let poll;
    let timeout;
    setFailed(false);
    onToken('');
    const fail = () => {
      if (!disposed) { onToken(''); setFailed(true); }
    };
    const render = () => {
      if (disposed || !window.turnstile?.render) return;
      clearInterval(poll);
      clearTimeout(timeout);
      try {
        widget = window.turnstile.render(container.current, {
          sitekey: SITE_KEY,
          action,
          callback: token => { if (!disposed) { setFailed(false); onToken(token); } },
          'expired-callback': () => { if (!disposed) onToken(''); },
          'error-callback': fail,
          'timeout-callback': fail
        });
      } catch { fail(); }
    };
    let script = document.querySelector('script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.dataset.jajogaTurnstile = 'true';
      document.head.appendChild(script);
    }
    const scriptFailed = () => {
      if (script.dataset.jajogaTurnstile) script.remove();
      clearInterval(poll);
      clearTimeout(timeout);
      fail();
    };
    script.addEventListener('error', scriptFailed);
    poll = setInterval(render, 100);
    timeout = setTimeout(() => { clearInterval(poll); fail(); }, 15000);
    render();
    return () => {
      disposed = true;
      clearInterval(poll);
      clearTimeout(timeout);
      script.removeEventListener('error', scriptFailed);
      if (widget !== undefined) window.turnstile?.remove(widget);
    };
  }, [action, onToken, resetKey, retry]);
  return <div className="turnstile-verification">
    <div ref={container} />
    {failed && <p role="alert">Verification could not load. <button type="button" onClick={() => setRetry(value => value + 1)}>Retry verification</button></p>}
  </div>;
}
